
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      positions: [],
    };
  },
  computed: {
    homeTeam () {
      return this.getTeam(this.fixture, `Home`);
    },
    awayTeam () {
      return this.getTeam(this.fixture, `Away`);
    },
    teamPositions () {
      if (this.positions.length) {
        const homePosition = this.positions.find(position => position.squad.teamId === this.homeTeam.teamId);
        const awayPosition = this.positions.find(position => position.squad.teamId === this.awayTeam.teamId);

        return [
          {
            team: this.homeTeam.team,
            position: homePosition,
          },
          {
            team: this.awayTeam.team,
            position: awayPosition,
          },
        ];
      }
      return [];
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getPositions();
    });
  },
  methods: {
    async getPositions () {
      const stage = this.fixture.stageId;
      const matchday = parseInt(this.fixture.matchday);
      const params = {
        include: `squad`,
        filter: {
          "stageId": stage,
          matchday,
          "squad.teamId": `${this.homeTeam.team.id}||${this.awayTeam.team.id}`,
        },
      };

      const request = await this.$getStats(`ladder`, params);
      if (request !== null) {
        this.positions = request.data;
      }

      if (!this.positions.length && matchday > 1) {
        // Get previous matchday's table
        params.filter.matchday = matchday - 1;
        const request = await this.$getStats(`ladder`, params);
        if (request !== null) {
          this.positions = request.data;
        }
      }
    },
    getPositionChangeIcon (team) {
      const current = parseInt(team.position.position);
      const prev = parseInt(team.position.previousPosition);
      return current === prev ? `minus` : current > prev ? `chevron-up` : `chevron-down`;
    },
  },
};
